export const RADIO_GLYPH_CLASS = "ApolloRadio-glyph";
export const RADIO_RING_CLASS = "ApolloRadio-ring";
export const RADIO_DOT_CLASS = "ApolloRadio-dot";

export const RADIO_VIEWBOX = 16;
export const RADIO_RING_STROKE = 4 / 3;
export const RADIO_DOT_RADIUS = 4;

const CENTER = RADIO_VIEWBOX / 2;

const RadioGlyph = () => (
  <svg
    className={RADIO_GLYPH_CLASS}
    viewBox={`0 0 ${RADIO_VIEWBOX} ${RADIO_VIEWBOX}`}
    aria-hidden
    focusable="false">
    <circle
      className={RADIO_RING_CLASS}
      cx={CENTER}
      cy={CENTER}
      r={CENTER - RADIO_RING_STROKE / 2}
      fill="none"
      stroke="currentColor"
      strokeWidth={RADIO_RING_STROKE}
    />
    <circle
      className={RADIO_DOT_CLASS}
      cx={CENTER}
      cy={CENTER}
      r={RADIO_DOT_RADIUS}
      fill="currentColor"
    />
  </svg>
);

export const RADIO_GLYPH = <RadioGlyph />;
